import React, { useState, useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css"; // Import AOS styles

const OpenSource = () => {
    const data = [
        {
            label: "Github",
            value: "github",
            cards: [
                {
                    title: "Skeleton",
                    repository: "Unknown/skeleton",
                    issueNumber: "#22099",
                    additions: 150,
                    deletions: 60,
                    repoLink: "https://github.com/prathamreet",
                    icon: "https://avatars.githubusercontent.com/u/118298875?s=200&v=4", // Profile pic of the repo
                },
            ],
        },
        {
            label: "Other",
            value: "other",
            cards: [
                {
                    title: "Body",
                    repository: "Unknown/body",
                    issueNumber: "#22099",
                    additions: 150,
                    deletions: 60,
                    repoLink: "https://github.com/prathamreet",
                    icon: "https://avatars.githubusercontent.com/u/118298875?s=200&v=4", // Profile pic of the repo
                },
            ],
        },
    ];

    // State for active tab
    const [activeTab, setActiveTab] = useState(data[0].value);

    // Initialize AOS
    useEffect(() => {
        AOS.init({
            duration: 800, // Animation duration in milliseconds
            once: false, // Whether animation should happen only once
        });
    }, []);

    return (
        <div className="container mx-auto rounded-lg shadow p-4 ubuntu-regular">
            <h2 className="text-2xl sm:text-3xl font-bold text-left">
                OpenSource Contributions
            </h2>

            {/* Buttons Section */}
            <div
                className="flex justify-center mb-4 space-x-4 lg:hidden"
                data-aos="zoom-in"
            >
                {/* Small screen zoom-in */}
                {data.map(({ label, value }) => (
                    <button
                        key={value}
                        onClick={() => setActiveTab(value)}
                        className={`py-2 px-4 rounded transition-colors duration-300 transform hover:scale-110 ${
                            activeTab === value
                                ? "bg-yellow-500 "
                                : "bg-gray-200 text-black"
                        }`}
                    >
                        {label}
                    </button>
                ))}
            </div>

            <div
                className="hidden lg:flex justify-center mb-4 space-x-4"
                data-aos="zoom-out-down"
            >
                {/* Large screen zoom-out-down */}
                {data.map(({ label, value }) => (
                    <button
                        key={value}
                        onClick={() => setActiveTab(value)}
                        className={`py-2 px-4 rounded transition-colors duration-300 transform hover:scale-110 ${
                            activeTab === value
                                ? "bg-yellow-500 "
                                : "bg-gray-200 text-black"
                        }`}
                    >
                        {label}
                    </button>
                ))}
            </div>

            {/* Cards Section */}
            <div
                className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3 overflow-y-auto"
                style={{ maxHeight: "400px" }}
            >
                {/* Small screen version (zoom-in) */}
                <div className="block lg:hidden" data-aos="zoom-in">
                    {data
                        .find((tab) => tab.value === activeTab)
                        ?.cards.map(
                            (
                                {
                                    title,
                                    repository,
                                    issueNumber,
                                    additions,
                                    deletions,
                                    repoLink,
                                    icon,
                                },
                                index
                            ) => (
                                <div
                                    key={index}
                                    className="p-4 rounded-lg shadow cursor-pointer transition-colors"
                                    onClick={() =>
                                        window.open(repoLink, "_blank")
                                    } // Redirect to repository
                                >
                                    {/* Contribution Details */}
                                    <div className="flex items-center mb-2">
                                        <div className="flex-shrink-0">
                                            <img
                                                className="h-8 w-8 rounded-full"
                                                src={icon}
                                                alt="Repo Icon"
                                            />
                                        </div>
                                        <div className="ml-3">
                                            <h3 className="text-lg font-bold">
                                                {title}
                                            </h3>
                                            <p className="text-sm text-gray-400">
                                                {repository}
                                            </p>
                                        </div>
                                    </div>
                                    <div className="text-gray-400 flex justify-between px-2 m-1">
                                        <p className="text-sm">{issueNumber}</p>
                                        <p className="text-sm">
                                            <span className="text-green-400">
                                                +{additions}
                                            </span>{" "}
                                            <span className="text-red-400">
                                                -{deletions}
                                            </span>
                                        </p>
                                    </div>
                                </div>
                            )
                        )}
                </div>

                {/* Large screen version (fade-up) */}
                <div className="hidden lg:block" data-aos="fade-up">
                    {data
                        .find((tab) => tab.value === activeTab)
                        ?.cards.map(
                            (
                                {
                                    title,
                                    repository,
                                    issueNumber,
                                    additions,
                                    deletions,
                                    repoLink,
                                    icon,
                                },
                                index
                            ) => (
                                <div
                                    key={index}
                                    className="p-4 rounded-lg shadow cursor-pointer transition-colors"
                                    onClick={() =>
                                        window.open(repoLink, "_blank")
                                    } // Redirect to repository
                                >
                                    {/* Contribution Details */}
                                    <div className="flex items-center mb-2">
                                        <div className="flex-shrink-0">
                                            <img
                                                className="h-8 w-8 rounded-full"
                                                src={icon}
                                                alt="Repo Icon"
                                            />
                                        </div>
                                        <div className="ml-3">
                                            <h3 className="text-lg font-bold">
                                                {title}
                                            </h3>
                                            <p className="text-sm opacity-65 ">
                                                {repository}
                                            </p>
                                        </div>
                                    </div>
                                    <div className="flex justify-between px-2 m-1">
                                        <p className="text-sm">{issueNumber}</p>
                                        <p className="text-sm">
                                            <span className="text-green-400">
                                                +{additions}
                                            </span>{" "}
                                            <span className="text-red-400">
                                                -{deletions}
                                            </span>
                                        </p>
                                    </div>
                                </div>
                            )
                        )}
                </div>
            </div>
        </div>
    );
};

export default OpenSource;
